
import React from "react";
import $ from "jquery";
import {
  updateThemeConfig,
} from "../../actions";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Button,
  Grid,
  IconButton,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { LoadingButton } from "@mui/lab";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

import { useEffect } from "react";
import { formatName } from "./ThemeConfig";
import SearchBackground from "./SearchBackground";
import GradiantBackground from "./GradiantBackground";
function BackgroundComponent({...props}) {
    const { theme_config} = useSelector(
        (state) => ({
          theme_config: state.theme_config
        })
    );
   const [openPa, setOpenPa] = React.useState(false);
    const dispatch = useDispatch()
    return (
    <Box sx={{padding:'15px 0 !important'}}>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={6}>
          <Typography>{formatName(props.field.name)}</Typography>
        </Grid>
        <Grid item xs={6} container alignItems="center" justifyContent="flex-end">
          <BackgroundDialog open={openPa} setOpenPa={setOpenPa}/>
        </Grid>
        {
          theme_config.background_image != "url()" &&
          <Grid item xs={12}>
              <Box
                onMouseOver={() => {
                    $(`#delete_background_btn`).css(
                    "opacity",
                    "1"
                    );
                }}
                onMouseOut={() => {
                    $(`#delete_background_btn`).css(
                    "opacity",
                    "0"
                    );
                }}
                onClick={()=>{setOpenPa(true)}}
                id={props.field.name}
                sx={{
                  cursor: "pointer",
                  height: "150px",
                  backgroundImage: theme_config.background_image,
                  backgroundPosition: "center top",
                  backgroundSize: "cover",
                  position:'relative'
                }}
                data-toggle="modal"
                data-target="#add-background-image-modal"
            >
              <Typography
                  onMouseOver={() => {
                      $(`#delete_background_btn`).css(
                      "opacity",
                      "1"
                      );
                  }}
                  onMouseOut={() => {
                      $(`#delete_background_btn`).css(
                      "opacity",
                      "0"
                      );
                  }}
                  id="delete_background_btn"
                  className="m-0 dlt_choice_btn"
                  onClick={(e) => {
                  dispatch(updateThemeConfig("background_image","url()"))
                  e.preventDefault();
                  e.stopPropagation();
                  }}
                  style={{ top: "-5px",color:"#000", right:"-5px", cursor:"pointer",position:"absolute"}}
              >
                  <CloseIcon fontSize="small" />
              </Typography>
            </Box>
          </Grid>
        }
      </Grid>
    </Box>
  );
}

export default BackgroundComponent;

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  
  function BackgroundDialog({ ...props }) {
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(props.open);
    const [image, setImage] = React.useState('')
    const [imageSearch, setImageSearch] = React.useState('')
    const [gradient, setGradient] = React.useState("linear-gradient(to bottom, #1488cc, #2b32b2)")
    const dispatch = useDispatch();
    const handleClickOpen = () => {
      setOpen(true);
      props.setOpenPa(true)
    };
  
    const handleClose = () => {
      setOpen(false);
      props.setOpenPa(false)
    };
    const handleDone = () =>{
      handleClose()
      dispatch(updateThemeConfig('background_image',value == 1 ? `url(${imageSearch})` : value == 2 ? gradient : `url(${image})`))
    }
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
    useEffect(() =>{
        setOpen(props.open)
    },[props.open])
    return (
      <>
        <IconButton
            size="small"
            onClick={handleClickOpen}
            color="secondary"
        >
            <AddIcon />
        </IconButton>
        <Dialog open={open} onClose={handleClose} >
          <DialogTitle><Typography variant="h5" fontWeight={'bold'} textAlign={"center"}>{"Add background"}</Typography></DialogTitle>
          <DialogContent>
            <Box sx={{width:'500px', height:'500px', padding:'0 !important'}}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  centered
                >
                  <Tab label="Upload" {...a11yProps(0)} />
                  <Tab label="Search" {...a11yProps(1)} />
                  <Tab label="Gradient" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <TabPanel value={value} index={0} style={{textAlign:"center"}}>
                <Box>
                  <LoadingButton
                  color="primary"
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<FileUploadIcon />}
                    variant="contained"
                  >
                    {image ? 'Replace image': 'Upload image'}
                    <input
                      style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        top: '0',
                        bottom: '0',
                        right: '0',
                        left: '0',
                        width: '100%',
                        opacity: '0'
                        }}
                        type="file"
                        accept="image/*"
                        onChange={(e)=>{
                          setLoading(true);
                          handleUploadImageToS3(e.target.files[0]).then(function(result) {
                            setLoading(false);
                            setImage(result.files[0].public_url)
                          })
                          .catch(function() {
                            // An error occurred
                          });
                        }}
                    />
                  </LoadingButton>
                        {
                          image &&
                          <img src={image} alt='background' style={{width:'100%', marginTop: '10px'}}/>
                        }
                </Box>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <SearchBackground imageSearch={imageSearch} setImageSearch={setImageSearch}/>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <GradiantBackground gradient={gradient} setGradient={setGradient}/>
              </TabPanel>
            </Box>
          </DialogContent>
          <DialogActions>
          <Button onClick={handleClose} autoFocus>
              Cancel
            </Button>
            <Button onClick={handleDone} color='primary' autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }
  
  function handleUploadImageToS3(file = null) {
    let fileName = Date.now().toString();
    let postData =
      '{"data":{"' +
      fileName +
      '_ExtraArgs":"{\\"ACL\\": \\"public-read-write\\"}","' +
      fileName +
      '_FileMeta":"{\\"project_code\\":\\"C026\\",\\"resource_type\\":\\"local.test.screenshot\\"}"},"files":{"' +
      fileName +
      '":"__file__"}}';
    postData = JSON.parse(postData);
    let ajaxData = {
      type: "POST",
      url: "https://storage.rta.vn/s3/upload",
      contentType: false,
      processData: false,
      // success: (res, status, xhr) => {
      //   return res.files[0].public_url
      // },
      // error: (xhr, status, error) => {
      //   return ''
      // },
      xhr: () => {
        let jqXHR = new XMLHttpRequest();
        jqXHR.withCredentials = false;
        jqXHR.open("POST", "https://storage.rta.vn/s3/upload");
        return jqXHR;
      },
      timeout: 10000,
    };
  
    let formData = new FormData();
    Object.keys(postData.data).map((keyName) =>
      formData.append(keyName, postData.data[keyName])
    );
    if (file) {
      Object.keys(postData.files).map((keyName) =>
        formData.append(keyName, file)
      );
    }
    ajaxData["data"] = formData;
    return $.ajax(ajaxData);
  }